import { jsxs, jsx } from 'react/jsx-runtime';
import { SpeedMetric } from '../../types/speed.js';

const WIDTH = 100;
const HEIGHT = 50;
const CORNER_RADIUS = 5;
// TODO - get these from tokens
const BACKGROUND_COLOUR = '#121212';
const FASTEST_COLOUR = '#790fa2';
const TEXT_COLOUR = '#FFF';
function Speed({ children, fastest = false, metric = SpeedMetric.MPH, x, y, }) {
    return (jsxs("g", { transform: `translate(${x}, ${y})`, children: [jsx("rect", { x: -WIDTH / 2, y: -HEIGHT / 2, width: WIDTH, height: HEIGHT, rx: CORNER_RADIUS, ry: CORNER_RADIUS, fill: fastest ? FASTEST_COLOUR : BACKGROUND_COLOUR }), jsx("text", { x: WIDTH / 10, y: HEIGHT / 6, textAnchor: "end", fontSize: HEIGHT / 2, fill: TEXT_COLOUR, children: children }), jsx("text", { x: (WIDTH / 10) * 1.5, y: HEIGHT / 6, textAnchor: "start", fontSize: HEIGHT / 4, fill: TEXT_COLOUR, children: metric })] }));
}

export { Speed as default };
//# sourceMappingURL=Speed.js.map
